<div class="header">
  <div class="header-content">
    <div class="start">
      <a [routerLink]="['/home']">
        <!-- <span>{{ 'ALINE' }}</span> -->
        <img src="/assets/images/Aline_logo-12.png" alt="Aline" width="100" />
      </a>
      <span class="organization-container" data-cy="organization">{{
        organization
      }}</span>
    </div>
    <div class="middle">
      @if (customer) {
        <span class="customer-header">
          <!-- Standalone role icon before customer info -->
          @if (customer.customerType === 'cd') {
            <span class="donors donors-color-cd"></span>
          }
          @if (customer.customerType === 'd') {
            <span class="donors donors-color-donor"></span>
          }
          @if (customer.customerType === 'e') {
            <span class="donors donors-color-ext"></span>
          }
          <a [routerLink]="[customerUrl, customer!.id]">
            <!-- Private healthcare customer: no gender icons, no frozen counts, no partner -->
            @if (customer.customerType === 'p') {
              <span class="selected-customer-chip">
                <span class="selected-customer-chip">
                  <span>
                    {{ customer!.age }} {{ customer!.firstName }}
                    {{ customer!.lastName }}
                  </span>
                  <span
                    class="header-personal-id"
                    (click)="$event.stopPropagation()"
                  >
                    {{ customer!.personalId }}
                    <span
                      class="copy-btn"
                      role="button"
                      tabindex="0"
                      (click)="copyPersonalId(customer!.personalId, $event)"
                      (keydown.enter)="
                        copyPersonalId(customer!.personalId, $event)
                      "
                      (keydown.space)="
                        copyPersonalId(customer!.personalId, $event)
                      "
                      [title]="'header.copy-ssn' | translate"
                    >
                      <i class="pi pi-copy"></i>
                    </span>
                  </span>
                </span>
              </span>
            }
            <!-- Regular customer / customer+donor -->
            @if (
              customer.customerType === 'c' || customer.customerType === 'cd'
            ) {
              <span class="selected-customer-chip">
                @if (
                  customer.customerType === 'c' ||
                  customer.customerType === 'cd'
                ) {
                  <span class="selected-customer-chip">
                    @if (isIvfLaboratory()) {
                      <span [class]="customer!.gender">
                        {{ customer!.age }} {{ customer!.firstName }}
                        {{ customer!.lastName }}
                        <i class="fas fa-temperature-low"></i>
                        {{ customer!.frozenStrawCount }} /
                        {{ customer!.frozenEmbryoCount }}
                      </span>
                    }
                    @if (!isIvfLaboratory()) {
                      <span [class]="customer!.gender">
                        {{ customer!.age }} {{ customer!.firstName }}
                        {{ customer!.lastName }}
                        @if (
                          customer.spermStrawCount !== undefined &&
                          customer.spermStrawCount !== null
                        ) {
                          <span
                            class="sperm-straw-count"
                            [title]="'common.spermStrawCount' | translate"
                          >
                            <i class="fas fa-temperature-low"></i>
                            {{ customer!.spermStrawCount }}
                          </span>
                        }
                      </span>
                    }
                    <span
                      class="header-personal-id"
                      data-cy="header-personal-id"
                      (click)="$event.stopPropagation()"
                    >
                      {{ customer!.personalId }}
                      <span
                        class="copy-btn"
                        role="button"
                        tabindex="0"
                        (click)="copyPersonalId(customer!.personalId, $event)"
                        (keydown.enter)="
                          copyPersonalId(customer!.personalId, $event)
                        "
                        (keydown.space)="
                          copyPersonalId(customer!.personalId, $event)
                        "
                        [title]="'header.copy-ssn' | translate"
                      >
                        <i class="pi pi-copy"></i>
                      </span>
                    </span>
                  </span>
                }
              </span>
            }
          </a>
          <!-- Private healthcare customer: address & phone next to name/SSN -->
          @if (
            customer.customerType === 'p' &&
            (contactAddressLine || contactPhone)
          ) {
            <span class="header-contact-info">
              @if (contactAddressLine) {
                <span>{{ contactAddressLine }}</span>
              }
              @if (contactPhone) {
                <span>{{ contactPhone }}</span>
              }
            </span>
          }
          <a [routerLink]="[donorUrl, customer!.id]">
            @if (customer.customerType === 'd') {
              <span class="selected-donor-chip">
                @if (isIvfLaboratory()) {
                  <span>
                    {{ customer!.firstName }} {{ customer!.lastName }}
                    <i class="fas fa-temperature-low"></i>
                    {{ customer!.frozenStrawCount }} /
                    {{ customer!.frozenEmbryoCount }}
                  </span>
                }
                @if (!isIvfLaboratory()) {
                  <span>
                    {{ customer!.firstName }} {{ customer!.lastName }}
                    @if (
                      customer.spermStrawCount !== undefined &&
                      customer.spermStrawCount !== null
                    ) {
                      <span
                        class="sperm-straw-count"
                        [title]="'common.spermStrawCount' | translate"
                      >
                        <i class="fas fa-temperature-low"></i>
                        {{ customer!.spermStrawCount }}
                      </span>
                    }
                  </span>
                }
                <span
                  class="header-personal-id"
                  (click)="$event.stopPropagation()"
                >
                  {{ customer!.personalId }}
                  <span
                    class="copy-btn"
                    role="button"
                    tabindex="0"
                    (click)="copyPersonalId(customer!.personalId, $event)"
                    (keydown.enter)="
                      copyPersonalId(customer!.personalId, $event)
                    "
                    (keydown.space)="
                      copyPersonalId(customer!.personalId, $event)
                    "
                    [title]="'header.copy-ssn' | translate"
                  >
                    <i class="pi pi-copy"></i>
                  </span>
                </span>
              </span>
            }
          </a>
          <a [routerLink]="[externalDonorUrl, customer!.id]">
            @if (customer.customerType === 'e') {
              <span class="selected-donor-chip">
                @if (isIvfLaboratory()) {
                  <span>
                    {{ customer!.sampleId }}
                    {{ customer!.donorInfo.luoteriCode }}
                    <i class="fas fa-temperature-low"></i>
                    {{ customer!.frozenStrawCount }} /
                    {{ customer!.frozenEmbryoCount }}
                  </span>
                }
                @if (!isIvfLaboratory()) {
                  <span>
                    {{ customer!.sampleId }}
                    {{ customer!.donorInfo.luoteriCode }}
                    @if (
                      customer.spermStrawCount !== undefined &&
                      customer.spermStrawCount !== null
                    ) {
                      <span
                        class="sperm-straw-count"
                        [title]="'common.spermStrawCount' | translate"
                      >
                        <i class="fas fa-temperature-low"></i>
                        {{ customer!.spermStrawCount }}
                      </span>
                    }
                  </span>
                }
              </span>
            }
          </a>
          @if (customer.partner && customer.customerType !== 'p') {
            <span class="partner"></span>
          }
          <!-- Standalone partner role icon -->
          @if (
            customer.partner?.customerType === 'cd' &&
            customer.customerType !== 'p'
          ) {
            <span class="donors donors-color-cd"></span>
          }
          @if (
            (customer.partner?.customerType === 'd' ||
              customer.partner?.customerType === 'e') &&
            customer.customerType !== 'p'
          ) {
            <span
              class="donors"
              [className]="
                customer!.partner?.customerType === 'e'
                  ? 'donors-color-ext'
                  : 'donors-color-donor'
              "
            ></span>
          }
          <a [routerLink]="[customerUrl, customer!.partner?.id]">
            @if (
              (customer.partner?.customerType === 'c' ||
                customer.partner?.customerType === 'cd') &&
              customer.customerType !== 'p'
            ) {
              <span class="selected-partner-chip">
                <span [class]="customer!.partner?.gender">
                  {{ customer!.partner?.firstName }}
                  {{ customer!.partner?.lastName }}
                </span>
                <span
                  class="header-personal-id"
                  data-cy="header-partner-personal-id"
                  (click)="$event.stopPropagation()"
                >
                  {{ customer!.partner?.personalId }}
                  <span
                    class="copy-btn"
                    role="button"
                    tabindex="0"
                    (click)="
                      copyPersonalId(customer!.partner?.personalId, $event)
                    "
                    (keydown.enter)="
                      copyPersonalId(customer!.partner?.personalId, $event)
                    "
                    (keydown.space)="
                      copyPersonalId(customer!.partner?.personalId, $event)
                    "
                    [title]="'header.copy-ssn' | translate"
                  >
                    <i class="pi pi-copy"></i>
                  </span>
                </span>
              </span>
            }
          </a>
          @if (
            customer.customerType !== 'p' &&
            (customer.partner?.customerType === 'd' ||
              customer.partner?.customerType === 'e')
          ) {
            <span class="selected-donor-partner-chip">
              <a [routerLink]="[donorUrl, customer!.partner?.id]">
                <span class="selected-donor-partner-chip">
                  {{ customer!.partner?.firstName }}
                  {{ customer!.partner?.lastName }}
                </span>
                <span
                  class="header-personal-id"
                  (click)="$event.stopPropagation()"
                >
                  {{ customer!.partner?.personalId }}
                  <span
                    class="copy-btn"
                    role="button"
                    tabindex="0"
                    (click)="
                      copyPersonalId(customer!.partner?.personalId, $event)
                    "
                    (keydown.enter)="
                      copyPersonalId(customer!.partner?.personalId, $event)
                    "
                    (keydown.space)="
                      copyPersonalId(customer!.partner?.personalId, $event)
                    "
                    [title]="'header.copy-ssn' | translate"
                  >
                    <i class="pi pi-copy"></i>
                  </span>
                </span>
              </a>
            </span>
          }
        </span>
      }
    </div>
    @if (showEndMenu && items) {
      <div class="end">
        <div class="item-container">
          <app-header-customer-selector
            [fieldName]="'selectedCustomer'"
            [userType]="userTypeCustomerDonor"
            [customerType]="'c'"
            [placeholderText]="'event.searchCriteria.customer' | translate"
            data-cy="header-search-customer"
          ></app-header-customer-selector>
          @for (item of items; track item) {
            <app-header-item
              [item]="item"
              (itemSelected)="onItemSelected($event)"
            ></app-header-item>
          }
          <span class="item">
            <app-manual-button></app-manual-button>
          </span>
          <span class="item">
            <div
              class="profile-icon icon"
              data-cy="profile"
              (click)="menu.toggle($event)"
            ></div>
            <p-menu
              #menu
              [popup]="true"
              [model]="profileMenu"
              data-cy="profile-menu"
            ></p-menu>
          </span>
        </div>
      </div>
    }
  </div>
</div>
